import {Component, Input, OnInit} from '@angular/core';
import { Subscription } from '../subscription.model';
import {SubscriptionService} from "../subscription.service";
import {firstValueFrom} from "rxjs";

@Component({
    selector: 'app-subscription-reference-card',
    templateUrl: './subscription-reference-card.component.html',
    standalone: false
})
export class SubscriptionReferenceCardComponent implements OnInit {
  @Input() subscription: Subscription;

  public isEdit = false;
  public reference: string;

  constructor(private subscriptionService: SubscriptionService) {}

  public ngOnInit() {
    this.reference = this.subscription.reference;
  }

  public edit() {
    this.isEdit = true;
  }

  public cancel() {
    this.reference = this.subscription.reference;
    this.isEdit = false;
  }

  public async onSave(reference: { data: string }) {
    const ref = reference.data;
    if (ref === this.subscription.reference) {
      this.isEdit = false;
      return;
    }

    try {
      await firstValueFrom(this.subscriptionService.setSubscriptionReference(this.subscription.appliance_id, ref))
      this.reference = ref;
      this.subscription.reference = ref;
      this.isEdit = false;
    } catch (e) {
      console.error(e);
    }
  }
}
